import React from 'react'
import DepositLimitsAnniversary from '@mobi/account/Areas/DepositLimit/Components/DepositLimitsAnniversary'
import { ReverificationBanner } from '@mobi/account/Areas/Reverification/Components/ReverificationBanner'
import { useReverificationRedirection } from '@mobi/account/Hooks'
import { FeatureFlags } from '@mobi/settings/featureFlags'
import { useShareBlackbookIncomingListener } from '@core/Areas/Blackbook/Hooks/useShareBlackbookIncomingListener'
import { resetMatchedRaceBetTypePersist } from '@core/Areas/RaceCard/Components/RaceCardContent/Components/LegacyKnockout/ViewModels/Betting-v2/Components/Pages/Workflow/BettingStateManagerViewModel'
import { ShareBetIncoming } from '@core/Areas/ShareBet/ShareBetIncoming'
import { Banner } from '@core/Components/Banner'
import { MainContainer } from '@core/Components/Containers'
import { useFeature, useLogon } from '@core/Utils/hooks'
import { useAppSeo } from '@core/Utils/hooks/useAppSeo'
import { useRefreshOnVersionUpgrade } from '@core/Utils/hooks/useRefreshOnVersionUpgrade'
import { useRegisterForMicrosoftDynamicsPushNotification } from '@core/Utils/hooks/useRegisterForMicrosoftDynamicsPushNotification'
import { FeaturedItems } from './Components/FeaturedItems'
import { HomeFooter } from './Components/Footer/HomeFooter'
import { HomeNavigation } from './Components/HomeNavigation'
import { HomeNextRaces } from './Components/HomeNextRaces'
import { InAppMarketing } from './Components/InAppMarketing/InAppMarketing'
import { MarketingOptInBanner } from './Components/MarketingOptInBanner'
import { Notification } from './Components/Notification/Notification'
import { TrendingBets } from './Components/TrendingBets/TrendingBets'
import { BannerCardStyled, HomeScrollWrapperStyled as ScrollerWrapper } from './Home.styles'

export const Home: React.FC = () => {
  const isInAppMarketingActive = useFeature(FeatureFlags.IN_APP_MARKETING.key)
  const isReverificationEnabled = useFeature(FeatureFlags.REMEDIATION_RE_VERIFICATION.key)
  const { accountNumber, isLoggedIn } = useLogon()
  useRefreshOnVersionUpgrade()
  useShareBlackbookIncomingListener()
  useRegisterForMicrosoftDynamicsPushNotification(accountNumber)
  useReverificationRedirection()

  useAppSeo({
    title: 'TABtouch | Online Betting, Racing & Sports Hub',
    description:
      'Bet on racing, AFL, NRL and sports with TABtouch. Explore odds, same game multis, race form, expert tips and live betting markets.',
  })

  React.useEffect(() => {
    resetMatchedRaceBetTypePersist()
  }, [])

  return (
    <MainContainer background='grey'>
      <ShareBetIncoming />

      {isReverificationEnabled && isLoggedIn && accountNumber && (
        <ReverificationBanner isDesktop={false} />
      )}

      <Notification isDesktop={false} />

      <MarketingOptInBanner />

      {isInAppMarketingActive && <InAppMarketing />}

      <BannerCardStyled>
        <Banner areaName='Home' />
      </BannerCardStyled>

      <HomeNavigation />

      <ScrollerWrapper>
        <HomeNextRaces />
        <FeaturedItems />
        <TrendingBets type='Single' />
        <TrendingBets type='SameRaceMulti' />
      </ScrollerWrapper>

      <HomeFooter />

      <DepositLimitsAnniversary accountNumber={accountNumber} />
    </MainContainer>
  )
}
